export default __webpack_public_path__ + "928634b427179f97534054ec2d4c89f0.webp";